import moment from "moment";
import {
  adminConsultationsExport,
  adminExportAppointmentByStatus,
} from "../../../config/service";

/** Trigger a browser download from CSV bytes returned as a blob response body. */
export function triggerCsvBlobDownload(blobData, downloadFilename) {
  const blob = new Blob([blobData], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = downloadFilename;
  a.rel = "noopener";
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

/**
 * View Meeting: single request for all selected statuses — server streams one merged CSV.
 */
export async function downloadMeetingCsvFromServer({
  statusTypes,
  allMeeting,
  search,
  lang,
  sortField,
  sortDir,
  filters,
}) {
  const trimmed = typeof search === "string" ? search.trim() : "";
  const body = {
    statuses: statusTypes,
    allMeeting: allMeeting === true,
    lang: lang === "HE" ? "HE" : "EN",
    ...(trimmed ? { search: trimmed } : {}),
    ...(sortField != null && sortDir != null
      ? { sortField, sortDir }
      : {}),
    ...(filters && Object.keys(filters).length > 0 ? { filters } : {}),
  };
  const res = await adminExportAppointmentByStatus(body);
  const label = statusTypes.join("-");
  triggerCsvBlobDownload(
    res.data,
    `${label}-${moment(new Date()).format("DD-MM-YYYY hh:mm A")}.csv`
  );
}

/**
 * Consultations page: server streams CSV from POST /admin/consultations/export (filters + sort + search).
 */
export async function downloadConsultationsCsvFromServer(body) {
  const res = await adminConsultationsExport(body);
  triggerCsvBlobDownload(res.data, `consultations-${Date.now()}.csv`);
}
